<template>
    <div>
        <span class="u-text" :style="{ color: txtcolor }" @click="onCode" :class="{ 'u-text-disabled': disabled }">
            {{ startText }}
        </span>

        <el-dialog custom-class="captcha-dialog rounded-lg" width="480px" title="" :visible.sync="imgShow" center :show-close="false"
            :append-to-body="true">
            <div class="captcha-content text-[#333] relative">
                <div class="captcha-header flex items-center justify-between mb-6">
                    <div class="captcha-title text-xl font-bold">{{ $t('获取验证码') }}</div>
                    <div class="captcha-tools">
                        <i class="el-icon-refresh-right text-3xl cursor-pointer" @click="onCode"></i>
                        <i class="el-icon-close text-3xl ml-6 cursor-pointer" @click="imgShow = false"></i>
                    </div>
                </div>
                <div class="captcha-image px-10">
                    <img :src="imgBase64" alt="" class="w-full">
                </div>
                <div class="captcha-actions mt-6 flex items-center justify-between">
                    <input type="text" v-model="code" :placeholder="$t('请输入验证码')"
                        class="captcha-input bottom-0 left-0 w-3/5 h-[40px] px-4 border border-[#ccc] rounded-md">
                    <button type="submit" class="captcha-confirm bottom-0 right-0 w-1/5 h-[40px] bg-[#48324F] text-white rounded-md"
                        @click="onConfirm">{{ $t('确认') }}</button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { postImgCode } from '@/api/index';

export default {
    name: 'CaptchaFetch',
    data() {
        return {
            startText: this.$t('获取验证码'),
            secNum: 60,
            changeText: '{count}秒后重新获取',
            canGetCode: true, // 是否可以执行验证码操作
            endText: this.$t('重新获取'),
            timer: null,

            imgShow: false,
            imgBase64: '',
            key: '',
            code: '',
        }
    },
    props: {
        txtcolor: {
            type: [String, Number],
            default: '#ffffff'
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        /**确认*/
        onConfirm() {
            if (this.canGetCode) {
                //写获取验证码接口
                this.$emit('onCode', this.key, this.code)
                // this.start()
            } else {
                this.$message({
                    message: this.$t('倒计时结束后再发送'),
                    type: 'warning'
                });
            }
        },
        onCode() {
            if (this.disabled) {
                return;
            }

            if (this.canGetCode) {
                //写获取验证码接口
                postImgCode().then(res => {
                    if (res.code == 1) {
                        let data = res.data;
                        this.imgBase64 = data.img;
                        this.key = data.key;
                        this.code = '';
                        this.imgShow = true;
                    }
                })
                // this.start()
            } else {
                this.$message({
                    message: this.$t('倒计时结束后再发送'),
                    type: 'warning'
                });
            }



        },
        // 开始倒计时
        start() {
            // 防止快速点击获取验证码的按钮而导致内部产生多个定时器导致混乱
            if (this.timer) {
                clearInterval(this.timer);
                this.timer = null;
            }
            // this.$emit('start');
            this.canGetCode = false;
            // 这里放这句，是为了一开始时就提示，否则要等setInterval的1秒后才会有提示
            this.changeEvent(this.$t(this.changeText, { count: this.secNum }));
            // this.setTimeToStorage();
            this.timer = setInterval(() => {
                // console.log(this.secNum);
                if (--this.secNum) {
                    // 用当前倒计时的秒数替换提示字符串中的"x"字母
                    this.changeEvent(this.$t(this.changeText, { count: this.secNum }));
                } else {
                    clearInterval(this.timer);
                    this.timer = null;
                    this.changeEvent(this.endText);
                    this.secNum = 60;
                    this.$emit('end');
                    this.canGetCode = true;
                }
            }, 1000);
        },
        changeEvent(text) {
            // console.log(text);
            this.startText = text
            // this.$emit('change', text);
        },
    },
};
</script>

<style scoped>
.u-text {
    color: #ffffff;
    cursor: pointer;
    font-size: 16px;
}

.u-text-disabled {
    color: #ccc !important;
    cursor: not-allowed;
}

input:focus {
    outline: none;
    border: 1px solid #ccc;
}

/* Element UI's dialog is appended to body, so its responsive styles need to pierce scoped CSS. */
::v-deep .captcha-dialog {
    max-width: calc(100vw - 32px);
}

@media screen and (max-width: 600px) {
    ::v-deep .captcha-dialog {
        width: calc(100% - 32px) !important;
        margin: 8vh auto !important;
    }

    ::v-deep .captcha-dialog .el-dialog__body {
        max-height: 84vh;
        padding: 20px;
        overflow-y: auto;
    }

    .captcha-header {
        margin-bottom: 20px;
    }

    .captcha-title {
        font-size: 18px;
    }

    .captcha-tools .el-icon-refresh-right,
    .captcha-tools .el-icon-close {
        font-size: 26px;
    }

    .captcha-tools .el-icon-close {
        margin-left: 16px;
    }

    .captcha-image {
        padding-right: 0;
        padding-left: 0;
    }

    .captcha-actions {
        flex-direction: column;
        align-items: stretch;
        gap: 12px;
    }

    .captcha-input,
    .captcha-confirm {
        width: 100%;
    }
}
</style>
